$('.footer-nav-title').on('click', function() {
	$(this).toggleClass('opened');
});

$('.footer-nav-title').on('resize', function() {
	$(this).removeClass('opened');
});

function initSlick() {
	if ($(window).width() < 1024) {
		if (!$('#footer-sponsors-logos').hasClass('slick-initialized')) {
			$('#footer-sponsors-logos').slick({
				autoplay: true,
				autoplaySpeed: 0,
				speed: 2000,
				cssEase: 'linear',
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				adaptiveHeight: false,
				dots: false,
				arrows: false,
				// prevArrow: $('.prev-slide'),
				// nextArrow: $('.next-slide'),
				// appendDots: $('.hero-slider--slider_dots--dots'),
				pauseOnFocus: true,
				pauseOnHover: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: 'unslick'
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 4,
							speed: 2500,
						}
					}
				]
			});
		}
	} else {
		if ($('#footer-sponsors-logos').hasClass('slick-initialized')) {
			$('#footer-sponsors-logos').slick('unslick');
		}
	}
}

$(window).on('load resize', function() {
	initSlick();
});

// // Mobile navigation toggle button function
// $(".header .navbar-toggler").on("click", function () {
//   if ($("body").hasClass("mobile-nav-open")) {
//     // hide mobile nav
//     $(".site-navigation").toggleClass("site-navigation-open");
//     $("body").toggleClass("mobile-nav-open");
//     $(".header").toggleClass("mobile-nav-open");
    
//     setTimeout(function() {
//       $("header").toggleClass("mobile-nav-open-z-index");
//     }, 360); // sum of transition duration and a bit more for class removing proccessing
//   } else {
//     // display mobile nav
//     $("header").toggleClass("mobile-nav-open-z-index");

//     setTimeout(function() {
//       $(".site-navigation").toggleClass("site-navigation-open");
//       $("body").toggleClass("mobile-nav-open");
//       $(".header").toggleClass("mobile-nav-open");
//     }, 60);
//   }
// });

// // Adding class on scroll for colored header
// var heroHeight = 70;
// // if ($(".hkpz-section.homepage-hero").length) {
// //   heroHeight = $(".hkpz-section.homepage-hero").height();
// //   heroHeight = heroHeight / 2;
// // }
// function hkpz_header_classes_on_load_and_scroll() {
//   if ($('header').hasClass('transparent-header')) {
//     var scroll = $(window).scrollTop();
//     if (scroll >= heroHeight) {
//       $(".header").addClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').removeClass('btn-light');
//     } else {
//       $(".header").removeClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').addClass('btn-light');
//     }
//   }
// }

// $(window).on("scroll", function () {
//   if ($('header').hasClass('transparent-header')) {
//     hkpz_header_classes_on_load_and_scroll();
//   }
// });
// $(window).on("load", function() {
//   setTimeout(() => {
//     hkpz_header_classes_on_load_and_scroll();
//   }, 500);
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const navbarToggler = document.querySelector('.header .navbar-toggler');
//   const body = document.body;
//   const header = document.querySelector('.header');
//   const siteNav = document.querySelector('.site-navigation');

//   if (navbarToggler && header && siteNav) {
//     navbarToggler.addEventListener('click', function () {
//       if (body.classList.contains('mobile-nav-open')) {
//         siteNav.classList.toggle('site-navigation-open');
//         body.classList.toggle('mobile-nav-open');
//         header.classList.toggle('mobile-nav-open');
//         setTimeout(function () {
//           document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
//         }, 360);
//       } else {
//         document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
//         setTimeout(function () {
//           siteNav.classList.toggle('site-navigation-open');
//           body.classList.toggle('mobile-nav-open');
//           header.classList.toggle('mobile-nav-open');
//         }, 60);
//       }
//     });
//   }

//   const heroHeight = 70;
//   const mainHeader = document.querySelector('header');
//   const scrollBtn = document.querySelector('.header .navbar-btn-wrap .btn.d-llg-flex');

//   function hkpz_header_classes_on_load_and_scroll() {
//     if (mainHeader && mainHeader.classList.contains('transparent-header')) {
//       const scroll = window.scrollY;
//       if (scroll >= heroHeight) {
//         mainHeader.classList.add('header-scrolled');
//         // scrollBtn?.classList.remove('btn-light');
//       } else {
//         mainHeader.classList.remove('header-scrolled');
//         // scrollBtn?.classList.add('btn-light');
//       }
//     }
//   }

//   window.addEventListener('scroll', hkpz_header_classes_on_load_and_scroll);

//   window.addEventListener('load', function () {
//     setTimeout(hkpz_header_classes_on_load_and_scroll, 500);
//   });
// });

// Mobile navigation toggle button function
$('.navbar-toggler').click(function () {
	$('.site-navigation').toggleClass('site-navigation-open');
	$('body').toggleClass('mobile-nav-open');
});

if ($('.hero').length) {
	var heroHeight = $('.hero').outerHeight();
} else {
	var heroHeight = 400;
}

// Adding class on scroll for colored header
$(window).scroll(function () {
	var scroll = $(window).scrollTop();

	if (scroll >= heroHeight) {
		// page hero height for changing nav font color on dark background images
		$('body').addClass('header-scrolled');
	} else {
		$('body').removeClass('header-scrolled');
	}
});

// Hide and show header depending on user scroll
// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.header').outerHeight();

$(window).scroll(function (event) {
	didScroll = true;
});

// setInterval(function () {
// 	if (didScroll) {
// 		hasScrolled();
// 		didScroll = false;
// 	}
// }, 250);

// function hasScrolled() {
// 	var st = $(this).scrollTop();

// 	// Make sure they scroll more than delta
// 	if (Math.abs(lastScrollTop - st) <= delta) return;

// 	// If they scrolled down and are past the navbar, add class .header-up.
// 	// This is necessary so you never see what is "behind" the navbar.
// 	if (st > lastScrollTop && st > navbarHeight) {
// 		// Scroll Down
// 		$('body').removeClass('header-down').addClass('header-up');
// 	} else {
// 		// Scroll Up
// 		if (st + $(window).height() < $(document).height()) {
// 			$('body').removeClass('header-up').addClass('header-down');
// 		}
// 	}

// 	lastScrollTop = st;
// }


// class Preloader {
// 	constructor(element) {
// 		this.rootElement = element;

// 		this.init();
// 	}

// 	init() {
// 		setTimeout(() => {
// 			this.rootElement.classList.add('is-open');

// 			setTimeout(() => {
// 				this.rootElement.remove();
// 				document.body.classList.remove('preloader-visible');

// 				setTimeout(() => {
// 					document.body.classList.add('preloader-out');
// 				}, 1000);
// 			}, 1000);
// 		}, 1000);

// 		this.setMultiplierVariable();

// 		window.addEventListener('scroll', () => {
// 			this.setMultiplierVariable();
// 		});
// 	}

// 	setMultiplierVariable() {
// 		const fullScroll = window.innerHeight / 1.2;
// 		const scrollTop = document.documentElement['scrollTop'] || document.body['scrollTop'];

// 		const isDone = scrollTop > fullScroll;
// 		const clickableContent = scrollTop > window.innerHeight / 5;

// 		document
// 			.querySelector('.preload-container-parallax')
// 			.classList.toggle('not-clickable', !clickableContent);

// 		document.documentElement.style.setProperty(
// 			'--scroll-multiplier',
// 			isDone ? 1 : scrollTop / fullScroll,
// 		);
// 	}
// }

// const preloader = document.querySelector('.preloader');

// if (preloader) {
// 	new Preloader(preloader);
// }


// header navigation click to open subnavigation
$('.header-hamburger-lg__link').on('click', function () {
	if ($(window).width() < 960) {
		$('.header-hamburger-lg__link').not(this).removeClass('opened');
		$(this).toggleClass('opened');
		var thisNode = $(this);

		if ($(this).hasClass('opened')) {
			setTimeout(function () {
				thisNode[0].scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}, 400);
		}
	}
});

$(window).on('resize', function () {
	$('.header-hamburger-lg__link').removeClass('opened'); // tu je bio $(this), provjeri
});

$(document).ready(function () {
	$('.header-hamburger-lg__sub-menu').hover(function () {
		$(this).prev().toggleClass('activeChild');
	});

	$('button.header-hamburger-lg__link, .header-hamburger-lg__sub-menu').hover(function () {
		$('#site-navigation').toggleClass('activeHover');
	});
});


// $.fn.isInViewport = function () {
//     let elementTop = $(this).offset().top;
//     let elementBottom = elementTop + $(this).outerHeight();
//     let viewportTop = $(window).scrollTop();
//     let viewportBottom = viewportTop + $(window).height();
//     return elementBottom > viewportTop && elementTop < viewportBottom;
// };

// $(window).on("load resize scroll", function () {
//     $('.animateOnEnter').each(function() {
//         if ( $(this).isInViewport() ) {
//             $(this).addClass('inView');
//         }
//     });
// });
document.addEventListener("DOMContentLoaded", () => {
  const elems = document.querySelectorAll('.animate-on-scroll');
  if (!('IntersectionObserver' in window)) {
    // fallback: prikaži odmah
    elems.forEach(el => el.classList.add('in-view'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        target.classList.add('in-view');
        io.unobserve(target);  // animiraj samo jednom
      }
    });
  }, {
    rootMargin: '0px 0px -15% 0px', // pokreće malo ranije
    threshold: 0
  });

  elems.forEach(el => io.observe(el));
});

// $('[data-toggle="scroll-to"]').click(function() {

//   var $this = $(this);

//   if ( $this.data('scroll-offset') == true ) {
//     var offset = $('.header').height();
//   } else {
//     var offset = 0;
//   }

//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       $('html, body').animate({
//         scrollTop: target.offset().top - offset
//       }, 1000);
//       return false;
//     }
//   }
// });







// ovo je radilo svugdje osim na art galeriji gdje trebamo horizontalni scroll
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('[data-toggle="scroll-to"]').forEach(function (link) {
//     link.addEventListener('click', function (e) {
//       e.preventDefault();

//       const useOffset = link.dataset.scrollOffset === 'true';
//       const offset = useOffset ? (document.querySelector('.header')?.offsetHeight || 0) : 0;

//       const currentPath = location.pathname.replace(/^\//, '');
//       const targetPath = link.pathname.replace(/^\//, '');
//       const isSamePage = currentPath === targetPath && location.hostname === link.hostname;

//       if (isSamePage) {
//         let target = document.querySelector(link.hash);
//         if (!target) {
//           target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
//         }

//         if (target) {
//           const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
//           window.scrollTo({
//             top: top,
//             behavior: 'smooth'
//           });
//         }
//       }
//     });
//   });
// });








$('[data-toggle="scroll-to"]').click(function() {

  var $this = $(this);

  if ( $this.data('scroll-offset') == true ) {
    var offset = $('.header').height();
  } else {
    var offset = 0;
  }

  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - offset
      }, 1000);
      return false;
    }
  }
});

// horizontal scroll for art pages
$('[data-toggle-horizontal="scroll-to"]').click(function() {

  viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  if (viewportWidth > 767) {
    
    const scrollContainer = document.getElementById("horizontal-wrap");
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('#horizontal-wrap').animate({
          scrollLeft: target.position().left
        },5000);
        return false;
      }
    }

  } else {
    
    var $this = $(this);

    if ( $this.data('scroll-offset') == true ) {
      var offset = $('.header').height();
    } else {
      var offset = 0;
    }

    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 1000);
        return false;
      }
    }

  }
});

// $(document).ready(function() {
// 	$("#skipper").click(function() {
// 		$('#mainContent').attr('tabIndex', -1).focus();
// 	})
// });
document.addEventListener('DOMContentLoaded', function () {
  const skipper = document.getElementById('skipper');
  const mainContent = document.getElementById('mainContent');

  if (skipper && mainContent) {
    skipper.addEventListener('click', function () {
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus();
    });
  }
});

// $(document).ready(function() {
// 	var width   = 981;
// 	var height  = 461;
// 	var left    = (screen.width / 2) - (width / 2);
// 	var top     = (screen.height / 2) - (height / 2);
// 	$('.js-share-link').click(function(e) {
// 		e.preventDefault();
// 		window.open(
// 		$(this).attr('href'),
// 		'',
// 		'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
// 		);
// 	});
// });
document.addEventListener('DOMContentLoaded', function () {
  const width = 981;
  const height = 461;
  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);

  const shareLinks = document.querySelectorAll('.js-share-link');

  shareLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.open(
        link.getAttribute('href'),
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,' +
        'width=' + width + ',height=' + height +
        ',top=' + top + ',left=' + left
      );
    });
  });
});
